<script lang="ts" setup>
interface Props {
  hint?: string | null
}
defineProps<Props>()
defineOptions({ inheritAttrs: false })
</script>

<template>
  <div :class="['text-sm leading-none', $attrs.class]">
    {{ hint || '&nbsp;' }}
  </div>
</template>
